import { PostedPost } from 'interfaces'
import { RefObject, useEffect, useRef } from 'react'

// Tracks the ids of the currently loaded posts in a ref so callbacks (e.g. select-all)
// always read the current set. Depends on the posts array identity rather than its length,
// so replacing posts with a same-length array still refreshes the ids.
export function usePostIdsRef(posts: PostedPost[]): RefObject<string[]> {
  const postsIdsRef = useRef<string[]>([])

  useEffect(() => {
    postsIdsRef.current = posts.map(p => p.id)
  }, [posts])

  return postsIdsRef
}

export default usePostIdsRef
